import { createApp } from 'vue';
import { createAgonI18n } from '../../i18n';
import Prices from './Prices.vue';
import { localeKey } from '../../common/keys';
import { createLocale, type LocaleDto } from '@agon/shared-utils';

interface RootProps {
  localeDto: LocaleDto;
}

declare const rootProps: RootProps;

const i18n = createAgonI18n(rootProps.localeDto.culture);

createApp(Prices, rootProps as never)
  .use(i18n)
  .provide(localeKey, createLocale(rootProps.localeDto))
  .mount('#app');
